export default __webpack_public_path__ + "static/media/大都会.fb366b97.jpg";